{
  "name": "howden-riskmap",
  "version": "4.5.4",
  "description": "",
  "title": "Mapa de Riesgos",
  "languages": [
    "es"
  ],
  "copyright": "Copyright 2015-2026 | Howden Iberia | Todos los derechos reservados",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-DevelopmentHowdenGroup": "ng build --configuration development",
    "build-StagingHowdenGroup": "ng build --configuration staging",
    "build-ProductionHowdenGroup": "ng build --configuration production",
    "build-Production-SchedulerHowdenGroup": "ng build --configuration production",
    "watch": "ng build --watch -c development",
    "test": "ng test",
    "lint": "eslint",
    "lint-and-fix": "eslint --fix",
    "i18n-extract": "ng extract-i18n --output-path=src/locale --progress=true"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@howdeniberia/core-front": "^21.0.4",
    "browser-detect": "^0.2.28",
    "echarts": "^6.1.0",
    "hammerjs": "^2.0.8",
    "html-to-image": "^1.11.13",
    "moment": "^2.31.0",
    "ngx-cookie-service": "^21.3.1",
    "ngx-echarts": "^20.0.2",
    "ngx-owl-carousel-o": "^21.0.3",
    "ngx-toastr": "~20.0.5",
    "rxjs": "~7.8.2",
    "subsink": "^1.0.2",
    "tslib": "^2.7.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^21.2.24",
    "@angular-devkit/schematics": "^21.2.24",
    "@angular/build": "^21.2.24",
    "@angular/cli": "^21.2.24",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/localize": "^21.2.25",
    "@eslint/js": "^9.10.0",
    "@schematics/angular": "21.2.24",
    "@types/eslint__js": "^8.42.3",
    "@types/jasmine": "^5.1.4",
    "@types/node": "^22.19.7",
    "angular-eslint": "19.8.1",
    "eslint": "^9.28.0",
    "jasmine-core": "^5.10.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "~8.67"
  }
}